import AuthService from "@/services/auth.service"
const initialState = { status: { isLoggedIn: false, live_status: "off" }, user: null, token: null, users: [], user_sessions: [] }

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit, dispatch }, creds) {
      return AuthService.login(creds).then(
        (res) => {
          commit("loginSuccess", res.data)
          dispatch("realtime/connect", null, { root: true })
          dispatch("data/getMyWorkspaceOrganizations", null, { root: true })

          return Promise.resolve(res.data)
        },
        (error) => {
          commit("loginFailure")
          return Promise.reject(error)
        }
      )
    },
    endUserLogin({ commit, dispatch }, creds) {
      return AuthService.endUserLogin(creds).then(
        (res) => {
          commit("setUser", res.data)

          dispatch("data/getMyWorkspaceOrganizations", null, { root: true })

          return Promise.resolve(res.data)
        },
        (error) => {
          commit("loginFailure")
          return Promise.reject(error)
        }
      )
    },
    magic_login({ state, commit, dispatch }, token) {
      window.localStorage.clear()
      commit("setIsLoggedIn", false)
      dispatch("realtime/disconnect", null, { root: true })
      commit("control/stateReset", null, { root: true })
      commit("data/stateReset", null, { root: true })
      commit("integration/stateReset", null, { root: true })
      commit("settings/stateReset", null, { root: true })
      commit("stateReset", null, { root: true })
      // remove the current user and keep the session
      commit("stateReset", {
        status: { isLoggedIn: false, live_status: "off" },
        user: null,
        token: null,
        users: [],
        user_sessions: state.user_sessions
      })
      return AuthService.magic_login(token).then(
        (res) => {
          commit("loginSuccess", res.data)
          dispatch("realtime/connect", null, { root: true })
          dispatch("data/getMyWorkspaceOrganizations", null, { root: true })
          return Promise.resolve(res.data)
        },
        (error) => {
          commit("loginFailure")
          return Promise.reject(error)
        }
      )
    },
    sessionLogin({ state, commit, dispatch }, token) {
      window.localStorage.clear()
      commit("setIsLoggedIn", false)
      dispatch("realtime/disconnect", null, { root: true })
      commit("control/stateReset", null, { root: true })
      commit("data/stateReset", null, { root: true })
      commit("integration/stateReset", null, { root: true })
      commit("settings/stateReset", null, { root: true })
      commit("stateReset", null, { root: true })
      // remove the current user and keep the session
      commit("stateReset", {
        status: { isLoggedIn: false, live_status: "off" },
        user: null,
        token: null,
        users: [],
        user_sessions: state.user_sessions
      })
      return AuthService.session_login(token).then(
        (res) => {
          commit("loginSuccess", res.data)
          dispatch("realtime/connect", null, { root: true })
          dispatch("data/getMyWorkspaceOrganizations", null, { root: true })
          return Promise.resolve(res.data)
        },
        (error) => {
          commit("loginFailure")
          return Promise.reject(error)
        }
      )
    },
    logout({ state, commit, dispatch }, router) {
      return AuthService.logout()
        .then(() => {
          window.localStorage.clear()
          commit("setIsLoggedIn", false)
          dispatch("realtime/disconnect", null, { root: true })
          commit("control/stateReset", null, { root: true })
          commit("data/stateReset", null, { root: true })
          commit("integration/stateReset", null, { root: true })
          commit("settings/stateReset", null, { root: true })
          commit("stateReset", null, { root: true })
          // remove the current user from the user sessions and reset the state
          commit("stateReset", {
            status: { isLoggedIn: false, live_status: "off" },
            user: null,
            token: null,
            users: [],
            user_sessions: state.user_sessions.filter((session) => session.id != state.user?.id)
          })
          if (router) {
            router.replace("/login")
          }
          return Promise.resolve()
        })
        .catch(() => {
          window.localStorage.clear()
          commit("setIsLoggedIn", false)
          dispatch("realtime/disconnect", null, { root: true })
          commit("control/stateReset", null, { root: true })
          commit("data/stateReset", null, { root: true })
          commit("integration/stateReset", null, { root: true })
          commit("settings/stateReset", null, { root: true })
          commit("stateReset", null, { root: true })
          // remove the current user from the user sessions and reset the state
          commit("stateReset", {
            status: { isLoggedIn: false, live_status: "off" },
            user: null,
            token: null,
            users: [],
            user_sessions: state.user_sessions.filter((session) => session.id != state.user?.id)
          })
          router.replace("/login")
          return Promise.resolve()
        })
    },
    logoutAllAccounts({ state, commit, dispatch }, router) {
      return AuthService.logout()
        .then(() => {
          window.localStorage.clear()
          commit("setIsLoggedIn", false)
          dispatch("realtime/disconnect", null, { root: true })
          commit("control/stateReset", null, { root: true })
          commit("data/stateReset", null, { root: true })
          commit("integration/stateReset", null, { root: true })
          commit("settings/stateReset", null, { root: true })
          commit("stateReset", null, { root: true })
          commit("stateReset", initialState)
          router.replace("/login")
          return Promise.resolve()
        })
        .catch(() => {
          window.localStorage.clear()
          commit("setIsLoggedIn", false)
          Object.assign(state, { status: { isLoggedIn: false, live_status: "off" }, user: null, token: null, users: [] })
          dispatch("realtime/disconnect", null, { root: true })
          commit("control/stateReset", null, { root: true })
          commit("data/stateReset", null, { root: true })
          commit("integration/stateReset", null, { root: true })
          commit("settings/stateReset", null, { root: true })
          commit("stateReset", null, { root: true })
          commit("stateReset", initialState)
          router.replace("/login")
          return Promise.resolve()
        })
    },
    refreshMe({ commit }) {
      return AuthService.fetchMe().then(
        (response) => {
          commit("refreshMe", response.data)
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },
    fetchUsers({ commit }) {
      return AuthService.fetchUsers().then(
        (response) => {
          commit("setUsers", response.data.results)
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },
    updateUser({ commit }, { id, data }) {
      return AuthService.updateUser(id, data).then(
        (response) => {
          commit("refreshMe", response.data)
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },
    updateOrganization({ commit }, { id, data }) {
      return AuthService.updateOrganization(id, data).then(
        (response) => {
          commit("setOrganization", response.data, { root: true })
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },
    updateLiveStatus: {
      root: true,
      handler({ commit }, { status }) {
        commit("updateLiveStatus", status)
      }
    },
    forceLogout: {
      root: true,
      handler({ commit, state, dispatch }) {
        Object.assign(state, { status: { isLoggedIn: false, live_status: "off" }, user: null, token: null, users: [] })
        commit("logout")
        dispatch("realtime/disconnect", null, { root: true })
        window.localStorage.clear()
        if (window.location.href.includes("workspace")) {
          window.location.href = "/workspace-login"
        } else {
          window.location.href = "/login"
        }
      }
    }
  },
  mutations: {
    stateReset(state, new_state) {
      Object.assign(state, new_state)
    },
    updateLiveStatus(state, status) {
      state.status.live_status = status
    },
    loginSuccess(state, user) {
      state.status.isLoggedIn = true
      state.user = user
      state.token = user.token

      // add the user the user_sessions if not already there
      if (!state.user_sessions.find((session) => session.id == user.id)) {
        state.user_sessions.unshift(user)
      }
    },
    setUser(state, user) {
      state.status.isLoggedIn = true
      state.user = user
      state.token = user.token
    },
    loginFailure(state) {
      state.status.isLoggedIn = false
      state.user = null
      state.token = null
    },
    logout(state) {
      state.status.isLoggedIn = false
      state.user = null
      state.token = null
    },

    setIsLoggedIn(state, status) {
      state.status.isLoggedIn = status
    },
    refreshMe(state, user) {
      state.user = user
    },

    setUsers(state, users) {
      state.users = users
    }
  }
}
